import { useTranslations } from "next-intl";
import { useSearchParams } from "@/hooks/useSearchParams";
import { SCard } from "@/components/Card/SCard";
import { Spacing } from "@/components/Spacing/Spacing";
import { AuthLayout } from "./AuthLayout";
import LoginForm from "./login/LoginForm";

export function LoginPage() {
  const t = useTranslations("login");
  const search = useSearchParams();
  const showResetSuccess = search.get("reset") === "success";

  return (
    <AuthLayout>
      <SCard header={t("loginTitle")} outline="outline-quaternary" shadow="shadow-xl">
        <Spacing height="h-6" />
        <LoginForm showResetSuccess={showResetSuccess} />
      </SCard>
    </AuthLayout>
  );
}
